var render = function render(){var _vm=this,_c=_vm._self._c;return _c('one-page-layout',[_c('div',{staticClass:"loading"}),_c('div',{staticClass:"loading__text"},[_vm._v("連線中...請稍候")])])
}
var staticRenderFns = []

export { render, staticRenderFns }